import request from '@/utils/axios';

// 根据url查询考试名称
export function selectExamManage(pValue) {
  return request({
    url:  `/system/examManage/getExamManage/${pValue}`,
    method: 'get',
  })
}

export function selectExamManageInfo(pValue) {
  return request({
    url:  `/system/examManage/getExamManageInfo/${pValue}`,
    method: 'get',
  })
}

export function examManageLogin(data) {
  return request({
    url:  `/system/examManage/examManageLogin`,
    method: 'post',
    data
  })
}

export function studentAnswerTimeApi(pValue) {
  return request({
    url:  `/system/examManage/studentAnswerTime/${pValue}`,
    method: 'post',
  })
}

export function getCurrentTime() {
  return request({
    url:  `/system/examManage/getCurrentTime`,
    method: 'get',
  })
}